import { Col, Row } from "reactstrap";

//images
import QuizImage from '../../assets/images/home/modal/quiz.png';

const Quiz = () => {

  return(
    <>
      <Row>
        <Col md="1"></Col>
        <Col md="10" className="text-center modal-home py-3">
          <p className="text-white text-center">
            <strong>Cara terbaik</strong> saat <strong>menerima informasi yang belum terverifikasi kebenarannya adalah <br/> melakukan <strong>cek fakta</strong> mandiri</strong>.
          </p>
          <img src={QuizImage} alt="quiz" />
          <p className="text-white text-center">
            Pada bagian ini, kamu akan diarahkan langsung <br/> bermain game edukasi. Melalui <strong>game</strong> tersebut kamu akan diajarkan beberapa <strong>materi dan teknik sederhana praktik cek fakta mandiri</strong>.
          </p>
          <p className="text-white text-center">
            Klik tombol di bawah ini untuk mulai permainan!
          </p>
        </Col>
        <Col md="1"></Col>
      </Row>
    </>
  );
}

export default Quiz